import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineChatIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M18 2H6a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h2.59l2.7 2.71A1.0003 1.0003 0 0 0 12 22c.2383 0 .4689-.0851.65-.24L15.87 19H18a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Zm1 14a1.0001 1.0001 0 0 1-1 1h-2.5c-.2383 0-.4689.0851-.65.24l-2.8 2.4-2.34-2.35A1.0004 1.0004 0 0 0 9 17H6a1.0002 1.0002 0 0 1-1-1V5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v11Z"/>
  </SvgIcon>
}

export default LineChatIcon
